import { Box, Flex, Button } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { Typography } from 'packages/common-frontend/components/Typography';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';
import { ExploDashboardContainer } from '~/packages/explo/ui/ExploDashboardContainer';

const RouteBase = () => {
  const { user } = useUserAuthOrThrow();

  return (
    <>
      <Flex justifyContent="space-between" mb="1.5rem">
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Limited Partners', path: `/limited-partners` },
          ]}
        />
        <Button
          variant="secondary"
          colorScheme="v2-aurora"
          as={RouterLink}
          to="/limited-partners/insights/report-builder"
        >
          Build Report
        </Button>
      </Flex>
      <Typography variant="page-title" trim>
        Insights
      </Typography>
      <Box mt="2.5rem">
        <ExploDashboardContainer
          organizationId={user.organization.id}
          exploPlacement="limitedPartnersDashboard"
        />
      </Box>
    </>
  );
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/limited-partners" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  );
};
